// extracted by mini-css-extract-plugin
export var productImage = "_nr-1";
export var viewLink = "_nr-2";
export var wishlistItem = "_nr-0";